import { BroadcastChannel } from "broadcast-channel";
export const authChannel = new BroadcastChannel('auth');
